// extracted by mini-css-extract-plugin
module.exports = {"main":"Component4_main__3M8Iu","line":"Component4_line__QasNr","title":"Component4_title__20vqV","value":"Component4_value__3qKAn"};